import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Breadcrumb as SeoBreadcrumb } from '@seo/breadcrumb';
import { useEffect, useState } from 'react';
import { useBreadcrumb } from '@/contexts/brandConfiguration/hooks';
export const Breadcrumb = ({ pageConfiguration, landingType, }) => {
    const breadcrumbData = useBreadcrumb(pageConfiguration, landingType);
    const [breadcrumb, setBreadcrumb] = useState(null);
    useEffect(() => {
        const loadBreadcrumb = async () => {
            try {
                const name = `${landingType.charAt(0).toUpperCase() + landingType.slice(1)}${pageConfiguration.charAt(0).toUpperCase() + pageConfiguration.slice(1)}`;
                const breadcrumb = await import(`../../../../public/data/breadcrumb/breadcrumb${name}.json`);
                setBreadcrumb(breadcrumb.default);
            }
            catch (error) {
                console.error('Error loading headInfos JSON:', error);
            }
        };
        loadBreadcrumb();
    }, [landingType]);
    if (!breadcrumb)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumb),
                } }), _jsx(SeoBreadcrumb, { links: [], data: breadcrumbData, marginHorizontal: "spacing.none", paddingLeft: "spacing.none" })] }));
};
